import { createRouter , createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'login',
    component:() => import('../views/login/loginIndex.vue'),
    meta: {
      title: '登录',
      forceLogin: false,
    }
  },
  {
    path: '/oidc/callback',
    name: 'oidcCallback',
    component:() => import('../views/login/oidcCallback.vue'),
    meta: {
      title: '统一认证登录',
      forceLogin: false,
    }
  },
  {
    path: '/',
    name: 'home',
    component:() => import('../views/home/homeIndex.vue'),
    meta: {
      title: 'FISHBONE工具箱',
    }
  },
  {
    path: '/life',
    name: 'life',
    component:() => import('../views/life/lifeIndex.vue'),
    meta: {
      title: '生活',
    }
  },
  {
    path: '/shouyi',
    name: 'shouyi',
    component:() => import('../views/life/shouYiIndex.vue'),
    meta: {
      title: '收益',
    }
  },
  {
    path: '/program',
    name: 'program',
    component:() => import('../views/program/programIndex.vue'),
    meta: {
      title: '编程',
    }
  },
  {
    path: '/json',
    name: 'json',
    component:() => import('../views/program/jsonIndex.vue'),
    meta: {
      title: 'JSON格式化',
    }
  },
  {
    path: '/jsonShow',
    name: 'jsonShow',
    component:() => import('../views/program/jsonShowIndex.vue'),
    meta: {
      title: 'JsonShow',
    }
  },
  {
    path: '/jsonView',
    name: 'jsonView',
    component:() => import('../views/program/jsonViewIndex.vue'),
    meta: {
      title: 'JsonView',
    }
  },
  {
    path: '/guid',
    name: 'guid',
    component:() => import('../views/program/guidIndex.vue'),
    meta: {
      title: 'GUID生成',
    }
  },
  {
    path: '/qrcode',
    name: 'qrcode',
    component:() => import('../views/program/qrcodeIndex.vue'),
    meta: {
      title: '二维码生成',
    }
  },
  {
    path: '/timestamp',
    name: 'timestamp',
    component:() => import('../views/program/timestampIndex.vue'),
    meta: {
      title: '时间戳转换',
    }
  },
  {
    path: '/gzip',
    name: 'gzip',
    component:() => import('../views/program/gzipIndex.vue'),
    meta: {
      title: 'Gzip压缩/解压',
    }
  },
  {
    path: '/aes',
    name: 'aes',
    component:() => import('../views/program/aesIndex.vue'),
    meta: {
      title: 'AES加密/解密',
    }
  },
  {
    path: '/urlEncode',
    name: 'urlEncode',
    component:() => import('../views/program/urlEncodeIndex.vue'),
    meta: {
      title: 'URL编码/解码',
    }
  },
  {
    path: '/base64',
    name: 'base64',
    component:() => import('../views/program/base64Index.vue'),
    meta: {
      title: 'BASE64编码/解码',
    }
  },
  {
    path: '/md5',
    name: 'md5',
    component:() => import('../views/program/md5Index.vue'),
    meta: {
      title: 'MD5加密',
    }
  },
  {
    path: '/calc',
    name: 'calc',
    component:() => import('../views/program/calcIndex.vue'),
    meta: {
      title: '网页计算器',
    }
  },
  {
    path: '/excelMerge',
    name: 'excelMerge',
    component:() => import('../views/program/excelMergeIndex.vue'),
    meta: {
      title: 'Excel合并',
    }
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
